import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgSearch = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <path
      fill="none"
      stroke="#007AFF"
      d="M12.435 1.075 2.358 11.152l-1.203 3.18 3.334-1.068L14.556 3.197l-2.121-2.122z"
    />
  </svg>
);
const Memo = memo(SvgSearch);
export default Memo;
